

import helpIcon from '../../assets/icons/helpToolTip/helptoolTip.svg';

import Tooltip from './Tooltip';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    name: string;
    type?: string;
    placeholder?: string;
    value?: string | number;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    error?: string;
    disabled?: boolean;
    optional?: boolean;
    tooltipContent?: string | React.ReactNode;
    className?: string;
    labelClassName?: string;
    inputClassName?: string;
    labelWidthClass?: string;
}

const Input = ({
    label,
    name,
    type = 'text',
    placeholder,
    value,
    onChange,
    error,
    disabled,
    optional,
    tooltipContent,
    className = '',
    labelClassName = '',
    inputClassName = '',
    ...props
}: InputProps) => {
    return (
        <div className={`${className}`}>
            {label && (
                <div className="flex items-center justify-between mb-[6px]">
                    <label htmlFor={name} className={`flex items-center font-noto font-medium text-[14px] text-[#667085] leading-[24px] ${labelClassName}`}>
                        <span className={`inline-block h-[24px] leading-[24px] ${props.labelWidthClass || 'w-auto'}`}>{label}</span>
                        {optional && <span className="font-noto font-normal text-[12px] text-[#667085] leading-[18px] inline-block w-[56px] h-[18px] ml-2">(Optional)</span>}
                    </label>
                    {tooltipContent && (
                        <Tooltip content={tooltipContent}>
                            <img
                                src={helpIcon}
                                alt="Help"
                                className="w-[16px] h-[16px] cursor-pointer"
                            />
                        </Tooltip>
                    )}
                </div>
            )}
            <input
                id={name}
                name={name}
                type={type}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className={`w-full px-3 h-[40px] border rounded-[6px] text-gray-700 focus:outline-none transition-colors
          ${error
                        ? 'border-red-500 focus:border-red-500'
                        : 'border-[#D0D5DD] focus:border-[#030407]'
                    }
          ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'} ${inputClassName}
        `}
                {...props}
            />
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
    );
};

export default Input;
